import { classNames } from '@/shared/lib/classNames/classNames';

type Alignment = 'left' | 'center' | 'right';

type CasesTableHeader = {
  title: string;
  subTitle?: string;
  align?: Alignment;
};

interface CasesTableProps {
  headers: CasesTableHeader[];
  rows: Array<Array<string | number>>;
  className?: string;
}

export const CasesTable = ({ headers, rows, className }: CasesTableProps) => {
  return (
    <div
      className={classNames({
        cls: 'custom-green-scrollbar custom-green-scrollbar-margin-right overflow-x-auto max-sm:min-w-[calc(100vw-16px)] max-sm:pb-4',
        additional: [className],
      })}
    >
      <div className="min-w-[597px] rounded-[28px] bg-[#283136] px-8">
        <table className="w-full table-fixed border-separate border-spacing-y-0 pb-5">
          <thead className="px-2">
            <tr>
              {headers.map((h, idx) => (
                <th
                  key={h.title}
                  className={classNames({
                    cls: 'h-[80px]',
                    mods: {
                      'pl-4': idx === 0,
                    },
                    additional: [
                      h.align === 'center'
                        ? 'text-center'
                        : h.align === 'right'
                          ? 'text-right'
                          : 'text-left',
                    ],
                  })}
                >
                  <div className="text-[14px] leading-[20px] font-bold">
                    {h.title}
                  </div>

                  {h.subTitle && (
                    <div className="text-[14px] leading-[20px] font-bold">
                      {h.subTitle}
                    </div>
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((cells, rowIdx) => (
              <tr
                key={`row-${rowIdx}`}
                className={classNames({
                  cls: 'h-[44px] rounded-[8px]',
                })}
              >
                {cells.map((cell, cellIdx) => (
                  <td
                    key={`cell-${rowIdx}-${cellIdx}`}
                    className={classNames({
                      cls: 'text-center',
                      mods: {
                        'pl-4': cellIdx === 0,
                        'text-left': cellIdx === 0,
                        'bg-[#323C41]': rowIdx % 2 === 0,
                        'rounded-l-[8px]': cellIdx === 0,
                        'rounded-r-[8px]': cellIdx === cells.length - 1,
                      },
                    })}
                  >
                    <span className="text-text-base-primary text-[16px] leading-[28px] max-sm:text-[14px] max-sm:leading-[20px]">
                      {cell}
                    </span>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
